//Common service for dealing with small tables

app.factory(
    'ShareUrlService', ['LocalStorage', 'ApiService', '$rootScope', ShareUrlService]
);

function ShareUrlService(LocalStorage, ApiService, $rootScope) {

    self.GenerateSharedUrl = GenerateSharedUrl;
    self.GetSharedContent = GetSharedContent;


    function GenerateSharedUrl(objectid, linkTypeId, lang) {
        return ApiService.get('/api/shareAPI/GenerateSharedUrl?objectid=' + objectid + "&linkTypeId=" + linkTypeId + "&lang=" + lang);
    }

    function GetSharedContent(sharedUrlVm) {
        return ApiService.post('/api/shareAPI/GetSharedContent', sharedUrlVm);
    }

    // private functions

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }


    return self;
}